import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";

import Notifications from "./containers/Notifications";

class NotificationRoutes extends Component {
  render() {
    return (
      <Switch>
        <Route
          exact
          path="/notifications"
          component={Notifications}
        />
      </Switch>
    )
  }
}

export default NotificationRoutes;



// WEBPACK FOOTER //
// ./src/features/notifications/routes.js